module.exports = __webpack_public_path__ + "static/img/afstereo-blurred.a144d0b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/afstereo-blurred.png
// module id = 2827
// module chunks = 3